<template>
<div>
    <!-- modal -->
    <b-modal id="lawSecurityDepositClientRefundMethodFormModal" centered size="lg" no-close-on-backdrop ref="lawSecurityDepositClientRefundMethodFormModal" :title=" $t('lawSecurityDepositClientRefundMethod.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-form>
                <label for="law-security-deposit-client-refund-method-name-input">{{ $t('lawSecurityDepositClientRefundMethod.type') }}</label>
                <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('lawSecurityDepositClientRefundMethod.type')" rules="required">
                        <b-form-input id="law-security-deposit-client-refund-method-name-input" v-model="name" size="sm" maxlength="50" :state="errors.length > 0 ? false:null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-form>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawSecurityDepositClientRefundMethodList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
        }
    },
    methods: {
        async showInfo(id) {
            this.$refs['lawSecurityDepositClientRefundMethodFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawSecurityDepositClientRefundMethod'
            }
            const payload = {
                data: data,
                controller: controller
            }
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.name = response.data.lawSecurityDepositClientRefundMethod.name
                } else {
                    this.$bvModal.hide('lawSecurityDepositClientRefundMethodFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }

        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name
            }
            const controller = {
                name: 'LawSecurityDepositClientRefundMethod'
            }
            const payload = {
                data: data,
                controller: controller
            }
            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawSecurityDepositClientRefundMethodFormModal')
                            this.getLawSecurityDepositClientRefundMethodList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }

                }

        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
